import _ from 'lodash'

interface NationalCode {
  valid: boolean
  cityCode: string
  ssn: string
  state: string
  city: string
}

// See http://www.aliarash.com/article/codemeli/codemeli.htm
export function parseNationalCode(code: string): NationalCode {
  const invalid = { valid: false, cityCode: '', ssn: '', state: '', city: '' }

  if (!/^\d{10}$/.test(code)) return invalid

  const control = parseInt(code.charAt(9))

  const computedControl =
    code
      .slice(0, 9)
      .split('')
      .reduce((acc, x, i) => acc + parseInt(x) * (10 - i), 0) % 11

  const valid =
    (computedControl < 2 && control == computedControl) ||
    (computedControl >= 2 && control + computedControl == 11)

  if (!valid) return invalid

  const cityCode = code.slice(0, 3)
  const ssn = code.slice(3, 9)
  const state = citiesStates[cityCode] ? citiesStates[cityCode][0] : ''
  const city = citiesStates[cityCode] ? citiesStates[cityCode][1] : ''

  return { valid, cityCode, ssn, state, city }
}

const citiesStates: any = {
  '105': ['خراسان رضوی', 'نیشابور'],
  '106': ['خراسان رضوی', 'نیشابور'],
  '108': ['اصفهان', 'نجف آباد'],
  '109': ['اصفهان', 'نجف آباد'],
  '110': ['اصفهان', 'فلاورجان'],
  '111': ['اصفهان', 'فلاورجان'],
  '112': ['اصفهان', 'فریدونشهر'],
  '113': ['اصفهان', 'خمینی شهر'],
  '114': ['اصفهان', 'خمینی شهر'],
  '115': ['اصفهان', 'فریدن'],
  '116': ['اصفهان', 'لنجان(زرینشهر)'],
  '117': ['اصفهان', 'لنجان(زرینشهر)'],
  '118': ['اصفهان', 'اردستان'],
  '119': ['اصفهان', 'شهرضا'],
  '120': ['اصفهان', 'سمیرم'],
  '121': ['اصفهان', 'گلپایگان'],
  '122': ['اصفهان', 'خوانسار'],
  '123': ['اصفهان', 'نطنز'],
  '124': ['اصفهان', 'نائین'],
  '125': ['اصفهان', 'کاشان'],
  '126': ['اصفهان', 'کاشان'],
  '127': ['اصفهان', 'اصفهان'],
  '128': ['اصفهان', 'اصفهان'],
  '129': ['اصفهان', 'اصفهان'],
  '136': ['آذربایجان شرقی', 'تبریز'],
  '137': ['آذربایجان شرقی', 'تبریز'],
  '138': ['آذربایجان شرقی', 'تبریز'],
  '145': ['اردبیل', 'اردبیل'],
  '146': ['اردبیل', 'اردبیل'],
  '149': ['آذربایجان شرقی', 'اهر'],
  '150': ['آذربایجان شرقی', 'اهر'],
  '152': ['اصفهان', 'میانه'],
  '153': ['اصفهان', 'میانه'],
  '154': ['آذربایجان شرقی', 'مراغه'],
  '155': ['آذربایجان شرقی', 'مراغه'],
  '157': ['اصفهان', 'مرند'],
  '158': ['اصفهان', 'مرند'],
  '159': ['آذربایجان شرقی', 'هشترود'],
  '160': ['آذربایجان شرقی', 'هشترود'],
  '161': ['اردبیل', 'مغان'],
  '162': ['اردبیل', 'مغان'],
  '163': ['اردبیل', 'خلخال'],
  '164': ['آذربایجان شرقی', 'سراب'],
  '165': ['آذربایجان شرقی', 'سراب'],
  '166': ['اردبیل', 'مشکین شهر'],
  '167': ['اردبیل', 'مشکین شهر'],
  '168': ['آذربایجان شرقی', 'بناب'],
  '169': ['آذربایجان شرقی', 'آذرشهر'],
  '170': ['آذربایجان شرقی', 'اسکو'],
  '171': ['آذربایجان شرقی', 'بستان آباد'],
  '172': ['آذربایجان شرقی', 'شبستر'],
  '173': ['آذربایجان شرقی', 'هریس'],
  '174': ['خوزستان', 'اهواز'],
  '175': ['خوزستان', 'اهواز'],
  '181': ['خوزستان', 'آبادان'],
  '182': ['خوزستان', 'خرمشهر'],
  '183': ['خوزستان', 'ایذه'],
  '184': ['خوزستان', 'ایذه'],
  '185': ['خوزستان', 'بهبهان'],
  '186': ['خوزستان', 'بهبهان'],
  '187': ['خوزستان', 'شوشتر'],
  '188': ['خوزستان', 'شوشتر'],
  '189': ['خوزستان', 'شادگان'],
  '190': ['خوزستان', 'رامهرمز'],
  '191': ['خوزستان', 'رامهرمز'],
  '192': ['خوزستان', 'اندیمشک'],
  '193': ['خوزستان', 'اندیمشک'],
  '194': ['خوزستان', 'بندرماهشهر'],
  '195': ['خوزستان', 'بندرماهشهر'],
  '196': ['خوزستان', 'مسجدسلیمان'],
  '197': ['خوزستان', 'مسجدسلیمان'],
  '198': ['خوزستان', 'دشت آزادگان'],
  '199': ['خوزستان', 'دزفول'],
  '200': ['خوزستان', 'دزفول'],
  '202': ['گلستان', 'گنبد کاووس'],
  '203': ['گلستان', 'گنبد کاووس'],
  '205': ['مازندران', 'بابل'],
  '206': ['مازندران', 'بابل'],
  '208': ['مازندران', 'ساری'],
  '209': ['مازندران', 'ساری'],
  '211': ['گلستان', 'گرگان'],
  '212': ['گلستان', 'گرگان'],
  '213': ['مازندران', 'آمل'],
  '214': ['مازندران', 'آمل'],
  '215': ['مازندران', 'قائمشهر'],
  '216': ['مازندران', 'قائمشهر'],
  '217': ['مازندران', 'بهشهر'],
  '218': ['مازندران', 'بهشهر'],
  '219': ['مازندران', 'نوشهر'],
  '220': ['مازندران', 'نوشهر'],
  '221': ['مازندران', 'تنکابن'],
  '222': ['مازندران', 'نور'],
  '223': ['گلستان', 'بندرترکمن'],
  '224': ['گلستان', 'کردکوی'],
  '225': ['مازندران', 'سوادکوه'],
  '226': ['گلستان', 'علی آباد'],
  '227': ['مازندران', 'رامسر'],
  '228': ['فارس', 'شیراز'],
  '229': ['فارس', 'شیراز'],
  '230': ['فارس', 'شیراز'],
  '236': ['فارس', 'کازرون'],
  '237': ['فارس', 'کازرون'],
  '238': ['فارس', 'ممسنی'],
  '239': ['فارس', 'ممسنی'],
  '240': ['فارس', 'آباده'],
  '241': ['فارس', 'آباده'],
  '242': ['فارس', 'مرودشت'],
  '243': ['فارس', 'مرودشت'],
  '244': ['فارس', 'فیروزآباد'],
  '245': ['فارس', 'فیروزآباد'],
  '246': ['فارس', 'جهرم'],
  '247': ['فارس', 'جهرم'],
  '248': ['فارس', 'داراب'],
  '249': ['فارس', 'داراب'],
  '250': ['فارس', 'لارستان'],
  '251': ['فارس', 'لارستان'],
  '252': ['فارس', 'استهبان'],
  '255': ['فارس', 'نی ریز'],
  '256': ['فارس', 'فسا'],
  '257': ['فارس', 'فسا'],
  '258': ['گیلان', 'رشت'],
  '259': ['گیلان', 'رشت'],
  '261': ['گیلان', 'آستارا'],
  '262': ['گیلان', 'طالش'],
  '263': ['گیلان', 'طالش'],
  '264': ['گیلان', 'بندرانزلی'],
  '265': ['گیلان', 'رودبار'],
  '266': ['گیلان', 'فومن'],
  '267': ['گیلان', 'صومعه سرا'],
  '268': ['گیلان', 'رودسر'],
  '269': ['گیلان', 'رودسر'],
  '270': ['گیلان', 'لنگرود'],
  '271': ['گیلان', 'لاهیجان'],
  '272': ['گیلان', 'لاهیجان'],
  '273': ['گیلان', 'آستانه'],
  '274': ['آذربایجان غربی', 'ارومیه'],
  '275': ['آذربایجان غربی', 'ارومیه'],
  '279': ['آذربایجان غربی', 'خوی'],
  '280': ['آذربایجان غربی', 'خوی'],
  '282': ['آذربایجان غربی', 'ماکو'],
  '283': ['آذربایجان غربی', 'ماکو'],
  '284': ['آذربایجان غربی', 'سلماس'],
  '285': ['آذربایجان غربی', 'سلماس'],
  '286': ['آذربایجان غربی', 'مهاباد'],
  '287': ['آذربایجان غربی', 'مهاباد'],
  '288': ['آذربایجان غربی', 'سردشت'],
  '289': ['آذربایجان غربی', 'پیرانشهر'],
  '290': ['آذربایجان غربی', 'نقده'],
  '291': ['آذربایجان غربی', 'سیه چشمه(چالدران)'],
  '292': ['آذربایجان غربی', 'بوکان'],
  '293': ['آذربایجان غربی', 'شاهین دژ'],
  '294': ['آذربایجان غربی', 'تکاب'],
  '295': ['آذربایجان غربی', 'اشنویه'],
  '296': ['آذربایجان غربی', 'میاندوآب'],
  '297': ['آذربایجان غربی', 'میاندوآب'],
  '298': ['کرمان', 'کرمان'],
  '299': ['کرمان', 'کرمان'],
  '302': ['کرمان', 'جیرفت'],
  '303': ['کرمان', 'جیرفت'],
  '304': ['کرمان', 'رفسنجان'],
  '305': ['کرمان', 'رفسنجان'],
  '306': ['کرمان', 'سیرجان'],
  '307': ['کرمان', 'سیرجان'],
  '308': ['کرمان', 'زرند'],
  '309': ['کرمان', 'زرند'],
  '310': ['کرمان', 'بم'],
  '311': ['کرمان', 'بم'],
  '312': ['کرمان', 'بافت'],
  '315': ['کرمان', 'کهنوج'],
  '316': ['کرمان', 'کهنوج'],
  '317': ['کرمان', 'بردسیر'],
  '318': ['کرمان', 'گلباف'],
  '319': ['کرمان', 'شهداد'],
  '320': ['کرمان', 'فهرج'],
  '321': ['کرمان', 'راور'],
  '322': ['کرمانشاه', 'پاوه'],
  '323': ['کرمانشاه', 'پاوه'],
  '324': ['کرمانشاه', 'کرمانشاه'],
  '325': ['کرمانشاه', 'کرمانشاه'],
  '330': ['کرمانشاه', 'کنگاور'],
  '331': ['کرمانشاه', 'هرسین'],
  '332': ['کرمانشاه', 'گیلانغرب'],
  '333': ['کرمانشاه', 'اسلام آباد'],
  '334': ['کرمانشاه', 'اسلام آباد'],
  '335': ['کرمانشاه', 'سنقر'],
  '336': ['کرمانشاه', 'سرپل ذهاب'],
  '338': ['هرمزگان', 'بندرعباس'],
  '339': ['هرمزگان', 'بندرعباس'],
  '341': ['هرمزگان', 'میناب'],
  '342': ['هرمزگان', 'میناب'],
  '343': ['هرمزگان', 'بندرلنگه'],
  '344': ['هرمزگان', 'بندرلنگه'],
  '345': ['هرمزگان', 'قشم'],
  '346': ['هرمزگان', 'جاسک'],
  '348': ['هرمزگان', 'بستک'],
  '349': ['بوشهر', 'بوشهر'],
  '350': ['بوشهر', 'بوشهر'],
  '351': ['بوشهر', 'دشتستان'],
  '352': ['بوشهر', 'دشتستان'],
  '353': ['بوشهر', 'بندر گناوه'],
  '354': ['بوشهر', 'دشتی'],
  '355': ['بوشهر', 'تنگستان'],
  '356': ['بوشهر', 'کنگان'],
  '357': ['بوشهر', 'دیر'],
  '358': ['سیستان و بلوچستان', 'ایرانشهر'],
  '359': ['سیستان و بلوچستان', 'ایرانشهر'],
  '361': ['سیستان و بلوچستان', 'زاهدان'],
  '362': ['سیستان و بلوچستان', 'زاهدان'],
  '364': ['سیستان و بلوچستان', 'چابهار'],
  '365': ['سیستان و بلوچستان', 'چابهار'],
  '366': ['سیستان و بلوچستان', 'زابل'],
  '367': ['سیستان و بلوچستان', 'زابل'],
  '369': ['سیستان و بلوچستان', 'سراوان'],
  '370': ['سیستان و بلوچستان', 'سراوان'],
  '371': ['سیستان و بلوچستان', 'خاش'],
  '372': ['کردستان', 'سنندج'],
  '373': ['کردستان', 'سنندج'],
  '375': ['کردستان', 'سقز'],
  '376': ['کردستان', 'سقز'],
  '377': ['کردستان', 'بیجار'],
  '378': ['کردستان', 'بیجار'],
  '379': ['کردستان', 'قروه'],
  '380': ['کردستان', 'قروه'],
  '381': ['کردستان', 'مریوان'],
  '383': ['کردستان', 'کامیاران'],
  '384': ['کردستان', 'بانه'],
  '386': ['همدان', 'همدان'],
  '387': ['همدان', 'همدان'],
  '392': ['همدان', 'ملایر'],
  '393': ['همدان', 'ملایر'],
  '394': ['کرمانشاه', 'کرند'],
  '395': ['همدان', 'نهاوند'],
  '396': ['همدان', 'نهاوند'],
  '397': ['همدان', 'تویسرکان'],
  '398': ['همدان', 'رزن'],
  '399': ['همدان', 'رزن'],
  '400': ['همدان', 'اسدآباد'],
  '401': ['همدان', 'اسدآباد'],
  '402': ['همدان', 'کبودرآهنگ'],
  '403': ['همدان', 'کبودرآهنگ'],
  '404': ['همدان', 'بهار'],
  '405': ['همدان', 'بهار'],
  '406': ['لرستان', 'خرم آباد'],
  '407': ['لرستان', 'خرم آباد'],
  '412': ['لرستان', 'بروجرد'],
  '413': ['لرستان', 'بروجرد'],
  '416': ['لرستان', 'الیگودرز'],
  '417': ['لرستان', 'الیگودرز'],
  '418': ['لرستان', 'الشتر'],
  '419': ['لرستان', 'کوهدشت'],
  '420': ['لرستان', 'نورآباد(دلفان)'],
  '421': ['لرستان', 'دورود'],
  '422': ['کهکیلویه و بویراحمد', 'بویراحمد(یاسوج)'],
  '423': ['کهکیلویه و بویراحمد', 'بویراحمد(یاسوج)'],
  '424': ['کهکیلویه و بویراحمد', 'کهکیلویه(دهدشت)'],
  '425': ['کهکیلویه و بویراحمد', 'کهکیلویه(دهدشت)'],
  '426': ['کهکیلویه و بویراحمد', 'گچساران(دوگنبدان)'],
  '427': ['زنجان', 'زنجان'],
  '428': ['زنجان', 'زنجان'],
  '431': ['قزوین', 'قزوین'],
  '432': ['قزوین', 'قزوین'],
  '438': ['قزوین', 'تاکستان'],
  '439': ['قزوین', 'تاکستان'],
  '442': ['یزد', 'یزد'],
  '443': ['یزد', 'یزد'],
  '444': ['یزد', 'اردکان'],
  '445': ['یزد', 'تفت'],
  '446': ['یزد', 'مهریز'],
  '447': ['یزد', 'بافق'],
  '448': ['یزد', 'میبد'],
  '449': ['ایلام', 'ایلام'],
  '450': ['ایلام', 'ایلام'],
  '451': ['ایلام', 'دهلران'],
  '452': ['ایلام', 'مهران'],
  '453': ['ایلام', 'شیروان و چرداول'],
  '454': ['ایلام', 'آبدانان'],
  '455': ['ایلام', 'دره شهر'],
  '456': ['سمنان', 'سمنان'],
  '457': ['سمنان', 'دامغان'],
  '458': ['سمنان', 'شاهرود'],
  '459': ['سمنان', 'شاهرود'],
  '460': ['سمنان', 'گرمسار'],
  '461': ['چهارمحال و بختیاری', 'شهرکرد'],
  '462': ['چهارمحال و بختیاری', 'شهرکرد'],
  '465': ['چهارمحال و بختیاری', 'بروجن'],
  '466': ['چهارمحال و بختیاری', 'لردگان'],
  '467': ['چهارمحال و بختیاری', 'فارسان'],
  '468': ['چهارمحال و بختیاری', 'اردل'],
  '469': ['هرمزگان', 'رودان'],
  '470': ['هرمزگان', 'گاوبندی'],
  '471': ['امور خارجه', 'امور خارجه'],
  '472': ['امور خارجه', 'امور خارجه'],
  '481': ['خوزستان', 'باغ ملک'],
  '483': ['لرستان', 'ازنا'],
  '484': ['لرستان', 'ازنا'],
  '486': ['گلستان', 'کلاله'],
  '487': ['گلستان', 'رامیان'],
  '488': ['گلستان', 'مینودشت'],
  '489': ['تهران', 'ساوجبلاغ'],
  '490': ['تهران', 'شهریار'],
  '491': ['تهران', 'شهریار'],
  '492': ['آذربایجان غربی', 'پلدشت'],
  '493': ['آذربایجان غربی', 'چایپاره'],
  '495': ['کرمانشاه', 'جوانرود'],
  '496': ['کرمانشاه', 'صحنه'],
  '497': ['گلستان', 'آق قلا'],
  '498': ['مازندران', 'بابل'],
  '499': ['مازندران', 'نکاء'],
  '500': ['مازندران', 'هراز و محمودآباد'],
  '501': ['مازندران', 'هراز و محمودآباد'],
  '502': ['همدان', 'فامنین'],
  '503': ['یزد', 'ابرکوه'],
  '504': ['اردبیل', 'پارس آباد'],
  '505': ['آذربایجان شرقی', 'جلفا'],
  '506': ['آذربایجان شرقی', 'عجب شیر'],
  '507': ['ملکان', 'ملکان'],
  '508': ['قزوین', 'آبیک'],
  '509': ['قزوین', 'بوئین زهرا'],
  '510': ['اصفهان', 'شاهین شهر'],
  '511': ['اصفهان', 'شاهین شهر'],
  '512': ['اصفهان', 'سمیرم سفلی (دهاقان)'],
  '513': ['فارس', 'بوانات'],
  '514': ['فارس', 'سروستان'],
  '515': ['فارس', 'لامرد'],
  '516': ['گیلان', 'ماسال و شاندرمن'],
  '517': ['گیلان', 'سیاهکل'],
  '518': ['گیلان', 'خمام'],
  '519': ['آذربایجان شرقی', 'کلیبر'],
  '520': ['سمنان', 'میامی'],
  '521': ['خراسان رضوی', 'جغتای'],
  '522': ['خراسان رضوی', 'چناران'],
  '523': ['خراسان جنوبی', 'درمیان'],
  '524': ['خراسان شمالی', 'مانه و سملقان'],
  '525': ['سیستان و بلوچستان', 'نیک شهر'],
  '526': ['خوزستان', 'شوش'],
  '527': ['خوزستان', 'آغاجاری'],
  '528': ['لرستان', 'ویسیان'],
  '529': ['بوشهر', 'بندر دیلم'],
  '530': ['سمنان', 'مهدیشهر'],
  '531': ['گلستان', 'مراوه تپه'],
  '532': ['بوشهر', 'سعد آباد'],
  '533': ['سیستان و بلوچستان', 'شهرکی و ناروئی(زهک)'],
  '534': ['ایلام', 'بدره'],
  '535': ['کرمان', 'کوهبنان'],
  '536': ['کرمان', 'رودبار کهنوج'],
  '537': ['هرمزگان', 'فین'],
  '538': ['قزوین', 'آوج'],
  '540': ['اصفهان', 'خور و بیابانک'],
  '541': ['اصفهان', 'مبارکه'],
  '542': ['کرمان', 'انار'],
  '543': ['یزد', 'هرات و مروست'],
  '544': ['مرکزی', 'فراهان'],
  '545': ['آذربایجان شرقی', 'ترکمانچای'],
  '546': ['فارس', 'بیضا'],
  '547': ['فارس', 'خشت و کمارج'],
  '548': ['فارس', 'خرامه'],
  '549': ['اصفهان', 'تیران و کرون'],
  '550': ['کهکیلویه و بویراحمد', 'لنده'],
  '551': ['یزد', 'اشکذر'],
  '552': ['یزد', 'نیر'],
  '553': ['خراسان رضوی', 'کلات'],
  '554': ['هرمزگان', 'خمیر'],
  '555': ['چهارمحال و بختیاری', 'کوهرنگ'],
  '556': ['تهران', 'اسلامشهر'],
  '557': ['لرستان', 'اشترینان'],
  '558': ['کردستان', 'دهگلان'],
  '559': ['قزوین', 'ضیاءآباد'],
  '561': ['یزد', 'بهاباد'],
  '562': ['خراسان رضوی', 'بجستان'],
  '563': ['خراسان جنوبی', 'نهبندان'],
  '564': ['اصفهان', 'جرقویه'],
  '565': ['اصفهان', 'کوهپایه'],
  '566': ['اردبیل', 'سنجبد(کوثر)'],
  '567': ['آذربایجان شرقی', 'ورزقان'],
  '568': ['مازندران', 'بندپی'],
  '569': ['گیلان', 'شفت'],
  '570': ['گیلان', 'رضوانشهر'],
  '571': ['مرکزی', 'وفس'],
  '572': ['خراسان رضوی', 'بردسکن'],
  '573': ['خراسان رضوی', 'جوین'],
  '574': ['خراسان رضوی', 'زبرخان'],
  '575': ['اصفهان', 'چادگان'],
  '576': ['مازندران', 'چهاردانگه'],
  '577': ['مازندران', 'شیرگاه'],
  '578': ['مازندران', 'دودانگه'],
  '579': ['مازندران', 'گلوگاه'],
  '580': ['قزوین', 'رودبار الموت'],
  '581': ['ایلام', 'ارکوازی(ملکشاهی)'],
  '582': ['مازندران', 'جویبار'],
  '583': ['کرمان', 'رابر'],
  '584': ['همدان', 'قلقل رود'],
  '585': ['خوزستان', 'اروندکنار'],
  '586': ['هرمزگان', 'بشاگرد'],
  '588': ['قزوین', 'طارم سفلی'],
  '590': ['قزوین', 'رودبار شهرستان'],
  '591': ['خراسان شمالی', 'رازوجرکلان'],
  '592': ['لرستان', 'پاپی'],
  '595': ['کرمانشاه', 'ثلاث باباجانی'],
  '596': ['کرمانشاه', 'روانسر'],
  '597': ['سیستان و بلوچستان', 'لاشار(اسپکه)'],
  '598': ['لرستان', 'رومشکان'],
  '599': ['کهکیلویه و بویراحمد', 'بهمنی'],
  '600': ['کهکیلویه و بویراحمد', 'چاروسا'],
  '601': ['اردبیل', 'بیله سوار'],
  '603': ['اردبیل', 'نیر'],
  '604': ['آذربایجان شرقی', 'هوراند'],
  '605': ['کرمان', 'ریگان'],
  '606': ['کرمان', 'عنبرآباد'],
  '607': ['کرمان', 'ماهان'],
  '608': ['کرمان', 'منوجان'],
  '609': ['بوشهر', 'جم'],
  '610': ['بوشهر', 'شبانکاره'],
  '611': ['سیستان و بلوچستان', 'میرجاوه'],
  '612': ['لرستان', 'چغلوندی'],
  '613': ['لرستان', 'چگنی'],
  '615': ['اصفهان', 'ابهر و خرمدره'],
  '616': ['ایلام', 'ایوان'],
  '617': ['مرکزی', 'خنداب'],
  '618': ['مرکزی', 'زرند مرکزی'],
  '619': ['اصفهان', 'آران و بیدگل'],
  '620': ['اصفهان', 'باغ بهادران'],
  '621': ['اصفهان', 'بوئین و میاندشت'],
  '622': ['اصفهان', 'میمه'],
  '623': ['گلستان', 'آزادشهر'],
  '625': ['مازندران', 'چمستان'],
  '626': ['مازندران', 'کجور'],
  '627': ['مازندران', 'کلاردشت'],
  '628': ['گلستان', 'گمیشان'],
  '629': ['چهارمحال و بختیاری', 'گندمان'],
  '630': ['گیلان', 'املش'],
  '631': ['گیلان', 'رحیم آباد'],
  '632': ['چهارمحال و بختیاری', 'فلارد'],
  '633': ['چهارمحال و بختیاری', 'کیار'],
  '634': ['ایلام', 'شیروان لومار'],
  '636': ['آذربایجان شرقی', 'چاروایماق'],
  '637': ['آذربایجان غربی', 'انزل'],
  '638': ['آذربایجان غربی', 'سیلوانه'],
  '640': ['آذربایجان غربی', 'شوط'],
  '641': ['کرمانشاه', 'حمیل'],
  '642': ['سمنان', 'بیارجمند'],
  '643': ['خراسان رضوی', 'احمدآباد'],
  '644': ['خراسان رضوی', 'تخت جلگه'],
  '646': ['کردستان', 'سروآباد'],
  '647': ['همدان', 'شراء و پیشخوار'],
  '648': ['فارس', 'ارسنجان'],
  '649': ['فارس', 'اوز'],
  '650': ['خراسان رضوی', 'رشتخوار'],
  '651': ['خراسان رضوی', 'فیض آباد'],
  '652': ['خراسان جنوبی', 'زیرکوه'],
  '653': ['گیلان', 'سنگر'],
  '654': ['فارس', 'حاجی آباد(زرین دشت)'],
  '655': ['فارس', 'خفر'],
  '656': ['فارس', 'کراش'],
  '657': ['فارس', 'مهر'],
  '658': ['تهران', 'پاکدشت'],
  '659': ['تهران', 'فیروزکوه'],
  '660': ['اصفهان', 'دولت آباد'],
  '661': ['خوزستان', 'هندیجان'],
  '662': ['خوزستان', 'رامشیر'],
  '663': ['خوزستان', 'اندیکا'],
  '664': ['تهران', 'کهریزک'],
  '665': ['فارس', 'سعادت آباد'],
  '666': ['تهران', 'رباط کریم'],
  '667': ['هرمزگان', 'ابوموسی'],
  '668': ['سیستان و بلوچستان', 'سیب و سوران'],
  '669': ['سیستان و بلوچستان', 'قصرقند'],
  '670': ['فارس', 'آباده طشک'],
  '671': ['فارس', 'جویم'],
  '673': ['فارس', 'شیبکوه'],
  '674': ['کردستان', 'کرانی'],
  '675': ['آذربایجان غربی', 'کشاورز'],
  '676': ['کردستان', 'نمشیر'],
  '677': ['آذربایجان غربی', 'تخت سلیمان'],
  '678': ['فارس', 'اشکنان'],
  '679': ['فارس', 'فراشبند'],
  '680': ['خوزستان', 'هویزه'],
  '681': ['فارس', 'قنقری(خرم بید)'],
  '682': ['سیستان و بلوچستان', 'بزمان'],
  '683': ['فارس', 'کوار'],
  '684': ['سمنان', 'ایوانکی'],
  '685': ['خوزستان', 'امیدیه'],
  '686': ['اردبیل', 'نمین'],
  '687': ['کهکیلویه و بویراحمد', 'باشت'],
  '688': ['کهکیلویه و بویراحمد', 'دروهان'],
  '689': ['گلستان', 'بندرگز'],
  '690': ['اردبیل', 'انگوت'],
  '691': ['کرمانشاه', 'باینگان'],
  '692': ['خوزستان', 'سردشت'],
  '693': ['گیلان', 'کوچصفهان'],
  '694': ['گیلان', 'لشت نشاء'],
  '695': ['تهران', 'طالقان'],
  '696': ['چهارمحال و بختیاری', 'میانکوه'],
  '697': ['کهکیلویه و بویراحمد', 'مارگون'],
  '698': ['کرمان', 'قلعه گنج'],
  '699': ['سیستان و بلوچستان', 'فنوج'],
  '700': ['سمنان', 'بسطام'],
  '701': ['سیستان و بلوچستان', 'دشتیاری'],
  '702': ['قم', 'کهک'],
  '703': ['سیستان و بلوچستان', 'بمپور'],
  '704': ['سیستان و بلوچستان', 'زابلی'],
  '705': ['سیستان و بلوچستان', 'شیب آب'],
  '706': ['خوزستان', 'بندر امام خمینی'],
  '707': ['خوزستان', 'شاوور'],
  '711': ['مازندران', 'بندپی شرقی'],
  '712': ['مازندران', 'عباس آباد'],
  '713': ['مازندران', 'میاندورود'],
  '714': ['اردبیل', 'خورش رستم'],
  '715': ['اردبیل', 'سرعین'],
  '716': ['خراسان جنوبی', 'سربیشه'],
  '717': ['تهران', 'نظرآباد'],
  '718': ['یزد', 'دستگردان'],
  '719': ['خراسان جنوبی', 'سرایان'],
  '720': ['سیستان و بلوچستان', 'راسک'],
  '721': ['خراسان جنوبی', 'بشرویه'],
  '722': ['کرمان', 'ارزونیه'],
  '723': ['فارس', 'قیروکارزین'],
  '724': ['خراسان رضوی', 'خلیل آباد'],
  '725': ['سیستان و بلوچستان', 'کنارک'],
  '726': ['ایلام', 'زرین آباد'],
  '727': ['ایلام', 'موسیان'],
  '728': ['قزوین', 'البرز'],
  '729': ['خوزستان', 'گتوند'],
  '730': ['خوزستان', 'لالی'],
  '731': ['اردبیل', 'ارشق'],
  '732': ['بوشهر', 'دلوار'],
  '001': ['تهران', 'تهران مرکزی'],
  '002': ['تهران', 'تهران مرکزی'],
  '003': ['تهران', 'تهران مرکزی'],
  '004': ['تهران', 'تهران مرکزی'],
  '005': ['تهران', 'تهران مرکزی'],
  '006': ['تهران', 'تهران مرکزی'],
  '007': ['تهران', 'تهران مرکزی'],
  '008': ['تهران', 'تهران مرکزی'],
  '011': ['تهران', 'تهران جنوب'],
  '015': ['تهران', 'تهران غرب'],
  '020': ['تهران', 'تهران شرق'],
  '025': ['تهران', 'تهرانشمال'],
  '031': ['تهران', 'کرج'],
  '032': ['تهران', 'کرج'],
  '037': ['قم', 'قم'],
  '038': ['قم', 'قم'],
  '041': ['تهران', 'ورامین'],
  '042': ['تهران', 'ورامین'],
  '043': ['تهران', 'دماوند'],
  '044': ['تهران', 'شمیران'],
  '045': ['تهران', 'شمیران'],
  '048': ['تهران', 'شهرری'],
  '049': ['تهران', 'شهرری'],
  '051': ['مرکزی', 'آشتیان'],
  '052': ['مرکزی', 'اراک'],
  '053': ['مرکزی', 'اراک'],
  '055': ['مرکزی', 'خمین'],
  '056': ['مرکزی', 'محلات'],
  '057': ['مرکزی', 'دلیجان'],
  '058': ['مرکزی', 'تفرش'],
  '059': ['مرکزی', 'ساوه'],
  '060': ['مرکزی', 'ساوه'],
  '061': ['مرکزی', 'سربند'],
  '062': ['مرکزی', 'سربند'],
  '063': ['خراسان شمالی', 'اسفراین'],
  '064': ['خراسان جنوبی', 'بیرجند'],
  '065': ['خراسان جنوبی', 'بیرجند'],
  '067': ['خراسان شمالی', 'بجنورد'],
  '068': ['خراسان شمالی', 'بجنورد'],
  '069': ['خراسان رضوی', 'تربت حیدریه'],
  '070': ['خراسان رضوی', 'تربت حیدریه'],
  '072': ['خراسان رضوی', 'تربت جام'],
  '073': ['خراسان رضوی', 'تربت جام'],
  '074': ['خراسان رضوی', 'تایباد'],
  '075': ['خراسان شمالی', 'جاجرم'],
  '076': ['خراسان رضوی', 'خواف'],
  '077': ['خراسان رضوی', 'درگز'],
  '078': ['خراسان رضوی', 'سبزوار'],
  '079': ['خراسان رضوی', 'سبزوار'],
  '081': ['خراسان رضوی', 'سرخس'],
  '082': ['خراسان شمالی', 'شیروان'],
  '083': ['یزد', 'طبس'],
  '084': ['خراسان رضوی', 'فریمان'],
  '085': ['خراسان جنوبی', 'فردوس'],
  '086': ['خراسان رضوی', 'قوچان'],
  '087': ['خراسان رضوی', 'قوچان'],
  '088': ['خراسان جنوبی', 'قائنات'],
  '089': ['خراسان رضوی', 'کاشمر'],
  '090': ['خراسان رضوی', 'کاشمر'],
  '091': ['خراسان رضوی', 'گناباد'],
  '092': ['خراسان رضوی', 'مشهد'],
  '093': ['خراسان رضوی', 'مشهد'],
  '094': ['خراسان رضوی', 'مشهد'],
  '096': ['خراسان رضوی', 'مشهد منطقه1'],
  '097': ['خراسان رضوی', 'مشهد منطقه2'],
  '098': ['خراسان رضوی', 'مشهد منطقه3'],
}

export const iranStates = _.uniq(
  Object.entries(citiesStates).map(([_, v]: any) => v[0]),
) as string[]

export const iranCities = (state: string) =>
  _.uniq(
    Object.entries(citiesStates)
      .filter(([_, v]: any) => v[0] === state)
      .map(([_, v]: any) => v[1]),
  ) as string[]
